export default {
  title: 'Employees',
  newEmployee: 'New Employee',
};
